@switch (iconName()) {
  @case ('graph') {
    <ic-graph [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-graph>
  }
  @case ('import') {
    <ic-import [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-import>
  }
  @case ('export') {
    <ic-export [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-export>
  }
  @case ('transit') {
    <ic-transit [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-transit>
  }
  @case ('emcs') {
    <ic-emcs [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-emcs>
  }
  @case ('warehouse') {
    <ic-warehouse [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-warehouse>
  }
  @case ('tasks') {
    <ic-tasks [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-tasks>
  }
  @case ('globe') {
    <ic-globe [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-globe>
  }
  @case ('commodity-classifier') {
    <ic-commodity-classifier [width]="width()" [height]="height()" [startColor]="color()" [endColor]="color()"></ic-commodity-classifier>
  }
}
